import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CATEGORY_ICON, TIER_COLORS, TIER_LABEL } from "@/data/brand";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-testid="categories-page">
      <header className="mb-12">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E619A8] mb-2">· Categorie</div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl leading-tight">Trova il tuo <span className="text-[#FFBE00]">settore</span>.</h1>
        <p className="mt-4 text-zinc-400 max-w-2xl">17 categorie per tutti i professionisti degli affitti brevi: fotografi, property manager, home stager, avvocati, commercialisti e molto altro.</p>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((c, i) => (
          <Link
            key={c.slug}
            to={`/categoria/${c.slug}`}
            className={`hm-card p-6 flex flex-col gap-3 ${i % 3 === 1 ? "hm-card-magenta" : ""}`}
            data-testid={`cat-${c.slug}`}
          >
            <div className="flex items-center justify-between">
              <i className={`fas ${CATEGORY_ICON[c.slug]} text-3xl ${i % 3 === 1 ? "text-[#E619A8]" : "text-[#FFBE00]"}`}></i>
              <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded border" style={{ color: TIER_COLORS[c.tier], borderColor: TIER_COLORS[c.tier] }}>
                {TIER_LABEL[c.tier]}
              </span>
            </div>
            <div className="font-heading font-bold text-xl leading-tight">{c.name}</div>
            <div className="text-sm text-zinc-400 mt-auto">
              <span className="text-white font-bold">€{c.pricing.monthly}</span>/mese · <span className="text-white font-bold">€{c.pricing.yearly}</span>/anno
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
